import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import authAxios from "../../config/authAxios"



const initialState = { status: null, message: "", loading: false, data: [], error: "" }


export const getPublisherDetailsAction = createAsyncThunk(
    'get-publisher-details',
    async (data, { rejectWithValue }) => {
        try {
            const res = await authAxios.get(`/pwa/api/get-publisher-detail`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getPublisherDetailsSlice = createSlice({
    name: 'get-publisher-details',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getPublisherDetailsAction.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(getPublisherDetailsAction.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.loading = false
                state.message = action.payload.message
                state.status = action.payload.status
            })
            builder.addCase(getPublisherDetailsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload.error
                state.message = action.payload.message
                state.status = action.payload.status
            })
        },

})



export const getPublisherDetailsReducer = getPublisherDetailsSlice.reducer